// src/pages/B2B/event-reports/pdf/warm/sections/WarmBroadcastBox.tsx
import React from 'react';
import type { EventReportPayload } from '../../../types';

function fmt(n: number): string { return n.toLocaleString(); }

export function WarmBroadcastBox({ payload }: { payload: EventReportPayload }): React.ReactElement {
  const a = payload.area_notifications;
  const dealViews = payload.businesses.reduce((s, b) => s + b.deal_views, 0);
  return (
    <div className="box">
      <h2>Broadcast reach</h2>
      <div className="box-grid">
        <div className="stat"><div className="lbl">Broadcasts sent</div><div className="val">{fmt(a.sent)}</div></div>
        <div className="stat"><div className="lbl">Audience</div><div className="val">{fmt(a.audience)}</div></div>
        <div className="stat"><div className="lbl">Received</div><div className="val">{fmt(a.delivered)}</div></div>
        <div className="stat"><div className="lbl">Deal views</div><div className="val">{fmt(dealViews)}</div></div>
      </div>
    </div>
  );
}
